import ServiceBase from '../ServiceBase';

export default class CreatorAdminService extends ServiceBase {
    searchCreators(filters = {}, pageSize = 0, pageIndex = 0) {
        return this.request('post', 'admin/creators/searchCreators', {
            pageSize,
            pageIndex,
            ...filters,
        });
    }

    getCreatorAdditionalInfo(creatorID) {
        return this.request('get', 'admin/creators/getCreatorAdditionalInfo', { params: { creatorID } });
    }
}